import { render, staticRenderFns } from "./OidcLogout.vue?vue&type=template&id=e3179e90"
import script from "./OidcLogout.vue?vue&type=script&lang=ts"
export * from "./OidcLogout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports